/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// d.ts
import { DCRecord } from '@/@types/lib/dataController';
import { IDataController } from '@/lib/DataController';

// Custom Components
import ModelTable from '@/ui/Table/ModelTable';
import DialogContext from '@/context/DialogContext/DialogContext';
import LoaderContext from '@/context/LoaderContext/LoaderContext';
import ImportRegistarProstornihPlanovaDialog from './ImportRegistarProstornihPlanovaDialog';
import RegistarProstornihPlanovaModel from '@/models/registar_prostornih_planova';
import dataController from '@/lib/DataController';
import { DialogContextType } from '@/context/DialogContext/DialogContext';
import { LoaderContextType } from '@/context/LoaderContext/LoaderContext';

function RegistarProstornihPlanovaTable() {
  const dialogContext = useContext<DialogContextType>(DialogContext);
  const loaderContext = useContext(LoaderContext) as LoaderContextType;

  const { t } = useTranslation();

  const [records, setRecords] = useState<DCRecord[]>([]);

  const dc: IDataController = new dataController(RegistarProstornihPlanovaModel);

  useEffect(() => {
    refreshRecords();
  }, []);

  const refreshRecords = () => {
    loaderContext.toggleLoading(true);
    dc.GetData()
      .then((resp) => {
        if (resp.success && Array.isArray(resp.data)) {
          setRecords(resp.data);
        } else {
          setRecords([]);
        }
      })
      .finally(() => {
        loaderContext.toggleLoading(false);
      });
  };

  const handleImport = () => {
    dialogContext.showDialog(ImportRegistarProstornihPlanovaDialog, {
      onClose: handleDialogClose,
    });
  };

  const handleDialogClose = (result: { dataChanged: boolean }) => {
    if (result?.dataChanged) {
      refreshRecords();
    }
  };

  return (
    <ModelTable
      title={t('admin:titles.registar_prostornih_planova')}
      records={records}
      dc={dc}
      allowSelection="one"
      allowFilter={true}
      allowExport={true}
      allowAdd={true}
      allowColumnPicker={true}
      addLabel={t('buttons.import') as string}
      handleAdd={handleImport}
      onRowAction={() => {}}
      allowRowAction={() => false}
      unselectRow={false}
    />
  );
}

export default RegistarProstornihPlanovaTable;
